import { styled } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';

import type { Place } from '../../../@types';
import { KioskType } from '../../../@types';
import { useKioskManager } from '../../../hooks/useKioskManager';
import { imageResize } from '../../../utils/images';
import styles from './locationButton.module.scss';

type LocationButtonProps = {
  place: Place;
  onClick: (place: Place) => void;
  active: boolean;
};

const LocationButton: React.FC<LocationButtonProps> = ({
  place,
  onClick,
  active,
}) => {
  const { kiosk, kioskMode } = useKioskManager();
  const imgUrl =
    imageResize(place?.media[0]?.image_url) ||
    '/images/cards/location-no-image.jpg';

  const kioskHeight =
    kiosk?.model === KioskType.ALL_MIGHTY
      ? '165px'
      : kiosk?.model === KioskType.BA_TABLET
        ? '247px'
        : '168px';

  const LocButton = styled(Button)(({ theme, className }) => ({
    width: '100%',
    height: 'auto',
    minHeight: kioskMode ? kioskHeight : '165px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    gap: '8px',
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '24px',
    padding: 0,
    paddingBottom: '16px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    textTransform: 'none',
    fontWeight: 400,
  }));

  return (
    <LocButton
      className={`
       ${styles.card}
        ${kiosk && kioskMode && styles[kiosk.model]}
        ${active && styles.active}
      `}
      onClick={() => onClick(place)}
    >
      <img
        src={imgUrl}
        alt={place.name}
        className={styles.card__image}
        aria-label={place.name}
      />
      <div className={styles.card__label}>{place.short_name || place.name}</div>
    </LocButton>
  );
};
export default LocationButton;
